// Ponte de token (cliente). Recupera no navegador o token de autenticação do
// app (app.orbitsender.com) via iframe invisível + postMessage, para o chat das
// docs poder (na Fase 4) consultar dados da conta do usuário logado.
//
// Segurança: só aceita mensagem vinda de APP_ORIGIN; a página bridge (estática,
// no app) só responde a origens permitidas (docs). Nunca persiste o token.

const APP_ORIGIN = process.env.NEXT_PUBLIC_APP_ORIGIN ?? 'https://app.orbitsender.com';
const BRIDGE_URL = `${APP_ORIGIN}/token-bridge.html`;
const TTL = 60_000;

let cache: { token: string | null; at: number } | null = null;

export function getAppToken(timeoutMs = 4000): Promise<string | null> {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (cache && Date.now() - cache.at < TTL) return Promise.resolve(cache.token);

  return new Promise((resolve) => {
    let done = false;
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.src = BRIDGE_URL;

    const finish = (token: string | null) => {
      if (done) return;
      done = true;
      cache = { token, at: Date.now() };
      window.removeEventListener('message', onMsg);
      clearTimeout(timer);
      try {
        iframe.remove();
      } catch {
        /* noop */
      }
      resolve(token);
    };

    const onMsg = (e: MessageEvent) => {
      if (e.origin !== APP_ORIGIN) return;
      if (!e.data || e.data.type !== 'orbit-token') return;
      finish(typeof e.data.token === 'string' ? e.data.token : null);
    };

    window.addEventListener('message', onMsg);
    iframe.onload = () => {
      try {
        iframe.contentWindow?.postMessage({ type: 'orbit-token-request' }, APP_ORIGIN);
      } catch {
        /* noop */
      }
    };
    const timer = setTimeout(() => finish(null), timeoutMs);
    document.body.appendChild(iframe);
  });
}

/** Limpa o cache do token (ex.: após logout). */
export function clearAppTokenCache() {
  cache = null;
}
